module.exports = __webpack_public_path__ + "static/media/EOCycle.71f7beab.PNG";